<template>
  <div class="banner">
    <Swiper :options="swiperOptions">
      <SwiperSlide class="swiper-slide" v-for="(item, index) in data" :key="index">
        <img :src="item.image" alt=""/>
      </SwiperSlide>
    </Swiper>
    <div class="swiper-pagination" slot="pagination"></div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const self = this;
    return {
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        on: {
          click() {
            self.handleClick(this.realIndex);
          },
        },
      },
    };
  },
  methods: {
    handleClick(idx) {
      const { novel_id: id = '' } = this.data[idx];
      if (!id) return;
      this.$emit('goDetail', id);
    },
  },
};
</script>
<style lang="less" scoped>
.banner {
  margin-top: 8px;
  .swiper-container {
    width: 328px;
    height: 183px;
    border-radius: 12px;
  }
  .swiper-pagination {
    position: relative;
    margin-top: 8px;
    /deep/ .swiper-pagination-bullet {
      margin: 0 2px;
      &.swiper-pagination-bullet-active {
        background: #3BDCBC;
      }
    }
  }
}
</style>
